import { Fragment, useEffect, useState } from "react";
import axios from "axios";
import { CONTENT_ROUTES } from "../routes/content-routes";
import Header from "../components/header";
import Footer from "../components/footer";
import { NavLink } from "react-router-dom";
import { AppLoader } from "../components/app-loader";
import { WEB_ROUTES } from "../routes/web-routes";
import TeamItem from "../components/leadership-item";
import { Helmet } from "react-helmet";
import { useUtilities } from "../hooks/utilities";

export default function BusinessIntegrity() {
  const [page, setPage] = useState({});
  const [loading, setLoading] = useState({});
  const [pageMedia, setPageMedia] = useState([]);

  const [sections, setSections] = useState([]);
  const [pageEDMedia, setPageEDMedia] = useState([]);

  let { getMetaSnippet, getSeoTitle, getSeoDescription } = useUtilities();

  useEffect(() => {
    setLoading(true);
    axios
      .get(CONTENT_ROUTES.POST_PAGE("/pages", "sustainability"))
      .then((res) => {
        const pageResponse = res.data?.length ? res.data[0] : {};

        const styledContent = pageResponse?.content?.rendered
          .replace(/<h2.*?>.*?<\/h2>/gs, "")
          .replace(/<p>/g, "<p class='mb-4'>")
          .replace(/<ul>/g, "<ul class='list-disc ml-6'>")
          .replace(/<a([^>]*?)>/g, `<a$1 class='text-[#58b947]'>`)
          .replace(
            /<li>(.*?)<\/li>/g,
            `<li class='flex items-start w-full'><i class="fi fi-rr-arrow-right text-xl float-left mt-1 -ml-5 mr-2 text-[#58b947]"></i><p>$1</p></li>`,
          );

        const matches = [
          ...styledContent.matchAll(
            /<h3 class="wp-block-heading">(.*?)<\/h3>([\s\S]*?)(?=<h3 class="wp-block-heading">|$)/g,
          ),
        ];

        const sections = matches.map((match) => ({
          title: match[1].trim(),
          body: match[2].trim(),
        }));

        setSections(sections);

        setPage(pageResponse);

        //Get page media
        axios
          .get(CONTENT_ROUTES.MEDIA_BY_PAGE(pageResponse?.id))
          .then((res) => {
            setPageMedia(res.data);
          });
      })
      .catch((err) => {})
      .finally(() => {});
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {getSeoTitle(page, page?.title?.rendered + ` - Nant Power`)}
        </title>
        <meta
          name="description"
          content={getSeoDescription(
            page,
            getMetaSnippet(page?.content?.rendered)
          )}
        />
      </Helmet>
      <Header />
      <main id="sustainability">
        <section className="relative">
          <div className="md:flex">
            <div className="md:w-3/12 w-full md:py-60 py-8 md:px-16 px-8 md:text-center text-left">
              <h1 className="text-left md:text-right text-4xl font-medium text-[#58b947]">
                {page?.title?.rendered}
              </h1>
            </div>
            <div
              className="px-8 md:px-0 relative md:w-9/12 w-full md:h-auto h-96 bg-no-repeat bg-center bg-cover"
              style={{
                backgroundImage: `url(${
                  pageMedia?.find((media) => media?.id === page?.featured_media)
                    ?.source_url
                })`,
              }}
            >
              <div className="absolute z-10 bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-black/60 to-transparent"></div>
              {/* Background image as a separate layer */}
              <div
                className="absolute md:top-[65px] top-[30px] md:left-[28%] left-0 md:h-full h-[420px] md:w-[500px] w-full z-30 bg-no-repeat md:bg-contain bg-[90%_auto] bg-center pointer-events-none"
                style={{
                  backgroundImage: `url("/images/electric-bolt-outline.svg")`,
                }}
              ></div>

              {/* Foreground content */}
              <div className="absolute md:pt-56 pt-48 top-0 md:left-[28%] left-0 h-full md:w-[500px] w-full z-30">
                <div
                  className="pt-2 md:pt-[100px] xl:pt-[80px] 2xl:pt-[60px] text-4xl font-medium z-30 w-80 text-center mx-auto "
                  dangerouslySetInnerHTML={{
                    __html: page?.content?.rendered
                      ?.match(/<h2[^>]*>.*?<\/h2>/gs)
                      ?.join(""),
                  }}
                />
              </div>
            </div>
          </div>
        </section>

        <section className="relative">
          {/* Background Layer */}
          <div className="absolute left-0 top-0 w-1/12 h-full bg-[#045994] z-30 md:block hidden"></div>
          <div className="absolute right-0 top-0 w-6/12 h-full bg-[#0070b9] md:block hidden"></div>

          <div className="divide-y divide-[#bad8ec] relative">
            {sections?.map((section, i) => (
              <div key={i} className="flex">
                <div
                  className={`md:w-3/12 w-2/12 bg-[#045994] relative ${
                    i === 0 && "md:pt-8 pt-16"
                  } ${i === sections.length - 1 && "pb-16"}`}
                >
                  <div
                    className={`absolute md:-right-12 -right-8 ${
                      i === 0 ? "md:top-24 top-28" : "md:top-16 top-12"
                    } z-20 md:w-24 w-16 md:h-24 h-16 bg-[#0e233f] md:text-4xl text-xl text-white md:content-center md:pt-0 pt-4 text-center font-bold rounded-full`}
                  >
                    {i + 1}
                  </div>
                </div>
                <div
                  className={`md:w-7/12 w-10/12 bg-[#0070b9] text-white ${
                    i === 0 && "md:pt-8 pt-16"
                  }  ${i === sections.length - 1 && "pb-16"}`}
                >
                  <div className="md:py-16 py-10 md:px-20 px-12">
                    <h3
                      className="wp-block-heading !text-2xl !font-normal"
                      dangerouslySetInnerHTML={{
                        __html: section.title,
                      }}
                    />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: section.body,
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="relative py-16 bg-gradient-to-b from-transparent to-[#bad8ec]">
          <div className="container mx-auto">
            <div className="md:w-full flex content-center md:px-0 px-8">
              <div className="flex">
                <img
                  className="mr-5 h-12 -mt-2"
                  src="/images/electric-bolt-solid.svg"
                  alt="Nant Power Project Icon"
                />
                <div className="text-xl font-bold text-gray-500">
                  Targets and Metrics
                </div>
              </div>
            </div>
          </div>
          <div className="container mx-auto md:flex ">
            {Array.from({ length: 5 }).map((_, i) => {
              const iconKey = `card_icon_${i + 1}`;
              const titleKey = `card_title_${i + 1}`;
              const bodyKey = `card_body_${i + 1}`;

              return (
                <div
                  key={i}
                  className="md:w-1/4 md:px-4 px-8 md:py-4 pt-4 pb-0 text-center md:inline-block flex"
                >
                  <div
                    className="bg-[#58b947] py-10 md:mx-auto mr-6 md:w-20 w-3/12 rounded-full md:mb-4 text-white text-4xl"
                    dangerouslySetInnerHTML={{
                      __html: page?.acf?.targets_metrics?.[iconKey],
                    }}
                  ></div>
                  <div className="md:w-full w-9/12 md:text-center text-left  content-center">
                    {/* <div className="text-[#58b947] font-medium text-xl">
                    {page?.acf?.targets_metrics?.[titleKey]}
                  </div> */}
                    <p>{page?.acf?.targets_metrics?.[bodyKey]}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
